import {Injectable} from 'ng-metadata/core';

import {FormBuilderService} from '../../../../../infra/formBuilder/formBuilder.service';
import {CallslipRequest} from './requestTypes/callslipRequest';
import {HoldRequest} from './requestTypes/holdRequest';
import {IllRequest} from './requestTypes/illRequest';
import {AcquisitionRequest} from './requestTypes/acquisitionRequest';
import {RecallRequest} from './requestTypes/recallRequest';
import {PhotocopyRequest} from './requestTypes/photocopyRequest';
import {ShortLoanRequest} from './requestTypes/shortLoanRequest';
import {UBRequest} from './requestTypes/ubRequest';
import {AlmaRequest} from './requestTypes/alma/AlmaRequest';
import {AlmaDigitization} from './requestTypes/alma/almaDigitization';
import {AlmaPurchaseRequest} from './requestTypes/alma/almaPurchaseRequest';
import {AlmaResourceSharing} from './requestTypes/alma/almaResourceSharing';
import {AlmaRequestAnyItem} from './requestTypes/alma/AlmaRequestAnyItem';
import {AlmaRequestOther} from './requestTypes/alma/AlmaRequestOther';
import {AlmaDigitizationOther} from './requestTypes/alma/almaDigitizationOther';
import {AlmaItemRequest} from './requestTypes/alma/almaItemRequest';
import {AlmaItemDigitization} from './requestTypes/alma/almaItemDigitization';
import {AlmaGeneralDigitization} from './requestTypes/alma/almaGeneralDigitization';

const cloneDeep = require('lodash/cloneDeep');


@Injectable()
export class RequestFromService {

    /* private members */
    private forms;

    constructor(private formBuilderService: FormBuilderService,
                callslipRequest: CallslipRequest,
                holdRequest: HoldRequest,
                illRequest: IllRequest,
				acquisitionRequest: AcquisitionRequest,
                recallRequest: RecallRequest,
                photocopyRequest: PhotocopyRequest,
                ubRequest: UBRequest,
                shortLoanRequest: ShortLoanRequest,
                almaRequest: AlmaRequest,
                almaDigitization: AlmaDigitization,
                almaPurchaseRequest: AlmaPurchaseRequest,
                almaResourceSharing: AlmaResourceSharing,
                almaRequestAnyItem: AlmaRequestAnyItem,
                almaRequestOther: AlmaRequestOther,
                almaDigitizationOther: AlmaDigitizationOther,
                almaItemRequest: AlmaItemRequest,
                almaItemDigitization: AlmaItemDigitization,
                almaGeneralDigitization: AlmaGeneralDigitization
    ) {
        this.forms = {
            HoldRequest: holdRequest,
            CallSlip: callslipRequest,
            AcquisitionRequest: acquisitionRequest,
            ILL: illRequest,
            Recall: recallRequest,
			PhotocopyRequest: photocopyRequest,
            UBRequest: ubRequest,
            ShortLoan: shortLoanRequest,
            AlmaRequest: almaRequest,
            AlmaDigitization: almaDigitization,
            AlmaPurchaseRequest: almaPurchaseRequest,
            AlmaResourceSharing: almaResourceSharing,
            AlmaRequestAnyItem: almaRequestAnyItem,
            AlmaRequestOther: almaRequestOther,
            AlmaDigitizationOther: almaDigitizationOther,
            AlmaItemRequest: almaItemRequest,
            AlmaItemDigitization: almaItemDigitization,
            AlmaGeneralDigitization: almaGeneralDigitization
        };

    }

    public getFormFields(service) {
        return cloneDeep(this.forms[service.type].getFields());
    }
    
    public getSectionsMap(service) {
        return cloneDeep(this.forms[service.type].getSectionsMap());
    }

    

    public getForm(service) {
        return this.forms[service.type];
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/opac/request/requestForms.service.ts